import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle, XCircle } from 'lucide-react';
const failedAttempts = ['Las limpiezas de jugos verdes están cargadas de fibra cruda que irrita tu colon y te inflama más.', 'Las dietas Keto extremas estresan tu metabolismo y disparan aún más la hormona del estrés.', 'Los entrenamientos de alto impacto a las 5 AM le dicen a tu cuerpo que estás en peligro, obligándolo a guardar agua en el abdomen.', "Los productos 'Sugar Free' de Walmart están llenos de químicos que destruyen tu microbiota digestiva."];
export function ProblemSection() {
  return <section className="py-20 px-4 bg-base" data-id="element-181">
      <div className="max-w-5xl mx-auto" data-id="element-182">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-183">
          <h2 className="font-heading text-3xl md:text-4xl text-primary mb-6" data-id="element-184">
            El verdadero problema no es lo que comes,{' '}
            <br className="hidden md:block" data-id="element-185" />
            <span className="text-cta" data-id="element-186">es cómo vives.</span>
          </h2>
          <p className="text-lg text-ink/80 max-w-3xl mx-auto leading-relaxed" data-id="element-187">
            Vivir en Estados Unidos siendo mamá es una carrera de obstáculos. El
            estrés crónico de los horarios, la comida procesada de los
            supermercados y la falta de sueño han activado una alarma en tu
            cuerpo: <strong data-id="element-188">el Cortisol</strong>.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-189">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-sage p-8 rounded-3xl" data-id="element-190">
            <div className="flex items-center gap-4 mb-6" data-id="element-191">
              <div className="bg-primary/10 p-3 rounded-full" data-id="element-192">
                <AlertTriangle className="w-8 h-8 text-primary" data-id="element-193" />
              </div>
              <h3 className="font-heading text-2xl text-ink" data-id="element-194">
                Modo Supervivencia
              </h3>
            </div>
            <p className="text-ink/80 leading-relaxed mb-4" data-id="element-195">
              Cuando el cortisol se dispara, tu cuerpo entra en modo
              "supervivencia". Esto significa que retiene líquidos, acumula
              gases y bloquea tu digestión.
            </p>
            <p className="text-ink/80 leading-relaxed font-medium" data-id="element-196">
              Por eso, aunque comas "ensaladitas", te sigues sintiendo como un
              globo a punto de estallar. Tu vientre hinchado es el grito de
              auxilio de un sistema inflamado por el estilo de vida americano.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-197">
            <h3 className="font-heading text-2xl text-ink mb-6" data-id="element-198">
              Por qué lo que has intentado NO funcionó:
            </h3>
            <div className="space-y-4" data-id="element-199">
              {failedAttempts.map((attempt, index) => <motion.div key={index} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start gap-3 bg-white p-4 rounded-xl shadow-sm border border-ink/5" data-id="element-200">
                  <XCircle className="w-6 h-6 text-cta shrink-0 mt-0.5" data-id="element-201" />
                  <p className="text-ink/80 text-sm md:text-base" data-id="element-202">{attempt}</p>
                </motion.div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}